/**
 * API Service for Google Sheets Integration
 */

const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || 'https://script.google.com/macros/s/AKfycbwQzIC889NGhta4IE2HkcrVE1s16byjVXsZmyB2PcQ5rk6se2I4UBd_RhYCSNw6lvTp/exec';

/**
 * Send a lead to Google Sheets
 */
export const createLead = async (leadData) => {
    try {
        await fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...leadData, action: 'addLead' }),
        });
        return { success: true };
    } catch (err) {
        console.error('Error adding lead:', err);
        return { success: false, error: 'Erro ao salvar lead na planilha.' };
    }
};

/**
 * Get site configurations from Google Sheets
 */
export const getSettings = async () => {
    try {
        const response = await fetch(GOOGLE_SCRIPT_URL);
        const data = await response.json();
        return { success: true, config: data.config };
    } catch (err) {
        console.error('Error fetching settings:', err);
        return { success: false, error: 'Erro ao carregar configurações.' };
    }
};

/**
 * Update site configurations in Google Sheets
 */
export const updateSettings = async (configs) => {
    try {
        // We use a regular POST here (not no-cors) because we need to know if it worked
        // However, Apps Script usually requires no-cors unless CORS is handled.
        // To be safe for now, we use no-cors.
        await fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'updateConfig', configs }),
        });
        return { success: true };
    } catch (err) {
        console.error('Error updating settings:', err);
        return { success: false, error: 'Erro ao atualizar configurações.' };
    }
};
